export default "__VITE_ASSET__3HMJ$L$f__"